import Axios from "../../../axios";
import { PredictAward, Headers } from "../../../axios/axios_config";
import { loadState, saveState } from '../../../redux/helper/local_storage_helper';

export const GET_INITIAL_METADATA = 'Hitmaker/GetInitialMetadata';
export const GET_CURRENT_METADATA = 'Hitmaker/GetCurrentMetadata';
export const RESET_DATA = 'Game/Reset';
export const GAME_PROGRESS = 'Game/GameProgress';
export const UPDATE_GAME_TAGS = 'Game/UpdateTags';
export const START_NEW_GAME = 'Game/StartNewGame';


// Chart
export const UPDATE_SORTED_LIST = 'Chart/UpdateSortedChart';
export const UPDATE_CHART_STATE = 'Chart/updateChartState';
export const UPDATE_CHART_LIST = 'Chart/UpdateChartList';

// Predict Award Show
export const UPDATE_SELECTED_NOMINEE = 'AwardShow/updateSelectedNominee';
export const UPDATE_PREDICT_AWARD = 'AwardShow/updatePredictAwardState';

// Music match
export const APPLY_BOOST = 'MusicMatch/applyBoost';
export const UPDATE_BONUS = 'MusicMatch/UpdateBonus';
export const UPDATE_MATCH_STATE = 'MusicMatch/UpdateMatchState';
export const UPDATE_SELECTED_MATCH = 'MusicMatch/UpdateSelectedMatch';

export const GetInitialMetadata = async (data, dispatch) => {
    await dispatch({
        type: GET_INITIAL_METADATA,
        payload: data
    })
}

export const getCurrentMetadata = (dataKey, data, dispatch) => {
    dispatch({
        type: GET_CURRENT_METADATA,
        payload: {
            dataKey,
            data
        }
    });
}

/**
 * To get the number of game entries and Game Jackpot prize
 * @param  {Number} Id
 * @param  {Number} gType
 * @param  {String} key
 * @param  {String} configName
 * @param  {Function} dispatch
 */
export const getGameEntries = (Id, gType, key, configName, dispatch) => {
    const gameEntries = loadState(key);
    if (!Id) return;
    if (!gameEntries) {
        Axios.get(`/api/Entries/${gType}/${Id}`, Headers())
            .then(response => {
                const { data } = response;
                if (data && data.Item) {
                    saveState(data.Item, key);
                    updateGameTags(configName, data.Item, dispatch);
                }
            })
            .catch(err => {
                console.log('Unable get Entries', err);
            });
    } else {
        updateGameTags(configName, gameEntries, dispatch);
    }
}

export const saveCurrData = (url, data) => {
    return Axios.post(url, { ...data }, Headers())
}



export const setGameProgress = (key, val, dispatch) => {
    dispatch({
        type: GAME_PROGRESS,
        payload: {
            key,
            val
        }
    });
}

export const updateGameTags = (key, val, dispatch) => {
    dispatch({
        type: UPDATE_GAME_TAGS,
        payload: {
            key,
            val
        }
    });
}

export const resetCurrData = (usergameId, _) => {
    return Axios.get(`/api/chart/delete/${usergameId}`, Headers())
}

export const resetData = (dataKey, dispatch) => {
    dispatch({
        type: RESET_DATA,
        payload: {
            dataKey
        }
    })
}

export const startNewGame = (key, val, dispatch) => {
    saveState(val, key);
}

// chart actions

export function updateSortedList(Item, dispatch) {
    dispatch({
        type: UPDATE_SORTED_LIST,
        payload: Item
    });
}

export function updateSongList(currItem, rank, dispatch) {
    dispatch({
        type: UPDATE_CHART_LIST,
        payload: {
            currItem,
            rank
        }
    });
}

export function updateChartState(value, dispatch) {
    dispatch({
        type: UPDATE_CHART_STATE,
        payload: value
    });
}


// music match actions

export function updateSelectedMatch(selected, dispatch) {
    dispatch({
        type: UPDATE_SELECTED_MATCH,
        payload: selected
    });
}

export function updateBonus(bonus, dispatch) {
    dispatch({
        type: UPDATE_BONUS,
        payload: bonus
    });
}

export function updateMatchState(value, dispatch) {
    dispatch({
        type: UPDATE_MATCH_STATE,
        payload: value
    });
}

export function applyBoost(boostItem, dispatch) {
    dispatch({
        type: APPLY_BOOST,
        payload: boostItem
    });
}


// predict award actions

export const getOpenAwardShows = (callback) => {
    Axios.get(PredictAward.getOpenEvents.url, Headers())
        .then((res) => {
            callback(res.data);
        }).catch(() => {
            callback(null);
            console.log('Can\'t get Award events');
        })
}

export function updatePredictAwardState(value, dispatch) {
    dispatch({
        type: UPDATE_PREDICT_AWARD,
        payload: value
    });
}

export function updateSelectedNominee(selected, dispatch) {
    dispatch({
        type: UPDATE_SELECTED_NOMINEE,
        payload: selected
    });
}